export const types = {
  // usuariosCargados: '[Chat] Usuarios cargados',
  activateChat: '[Chat] Activate Chat',
  newMessage: '[Chat] New Message',
  loadMessages: '[Chat] Load Messages',
  cleanMessages: '[Chat] Clean Messages',
  // cerrarSesion: '[Chat] Cerrar sesion',
}